// Read only bounded MP4/MOV metadata; never load the recording body into memory.
const EPOCH = Date.UTC(1904, 0, 1);
const MAX_MOOV = 16 * 1024 * 1024;
const valid = date => Number.isFinite(date?.getTime()) && date.getFullYear() >= 2000 && date <= new Date(Date.now() + 86400000);
const typeAt = (view, at) => String.fromCharCode(...new Uint8Array(view.buffer, view.byteOffset + at, 4));
export async function recordingTime(file) {
  try {
    if (/\.(mp4|mov|m4v)$/i.test(file.name)) {
      let offset = 0;
      for (let count = 0; count < 200 && offset + 8 <= file.size; count++) {
        const header = new DataView(await file.slice(offset, offset + 16).arrayBuffer());
        let size = header.getUint32(0), start = 8;
        if (size === 1) { size = header.getUint32(8) * 4294967296 + header.getUint32(12); start = 16; }
        if (size === 0) size = file.size - offset;
        if (!Number.isSafeInteger(size) || size < start || offset + size > file.size) break;
        if (typeAt(header, 4) === 'moov' && size <= MAX_MOOV) {
          const view = new DataView(await file.slice(offset + start, offset + size).arrayBuffer());
          for (let at = 0, n = 0; at + 8 <= view.byteLength && n < 500; n++) {
            const length = view.getUint32(at);
            if (length < 8 || at + length > view.byteLength) break;
            if (typeAt(view, at + 4) === 'mvhd' && length >= 20) {
              const version = view.getUint8(at + 8);
              const seconds = version === 0 ? view.getUint32(at + 12) : version === 1 && length >= 32 ? view.getUint32(at + 12) * 4294967296 + view.getUint32(at + 16) : NaN;
              const date = new Date(EPOCH + seconds * 1000);
              if (valid(date)) return { timestamp: date.toISOString(), source: 'Embedded video creation time (UTC)', confirmed: true };
            }
            at += length;
          }
        }
        offset += size;
      }
    }
  } catch { /* Unsupported metadata is reviewed using the fallback below. */ }
  const match = file.name.match(/(?:^|\D)(20\d{2})[-_]?(\d{2})[-_]?(\d{2})[T _-]?(\d{2})[:_-]?(\d{2})[:_-]?(\d{2})(?:\D|$)/);
  if (match) {
    const [, y, m, d, h, min, sec] = match.map(Number);
    const date = new Date(y, m - 1, d, h, min, sec);
    if (valid(date) && date.getMonth() === m - 1 && date.getDate() === d && date.getHours() === h && date.getMinutes() === min && date.getSeconds() === sec)
      return { timestamp: date.toISOString(), source: 'Filename time — confirm camera time zone', confirmed: false };
  }
  const fallback = new Date(file.lastModified);
  return { timestamp: valid(fallback) ? fallback.toISOString() : '', source: 'File modified time — confirm recording time', confirmed: false };
}
export function localRecordingTime(timestamp) {
  const date = new Date(timestamp);
  return valid(date) ? new Date(date - date.getTimezoneOffset() * 60000).toISOString().slice(0, 19) : '';
}
